import { ButtonPrimary } from 'components/Button'
import Column from 'components/Column'
import React, { useState } from 'react'
import styled from 'styled-components/macro'

import { agent } from '../api/agent'

export const TextInput = styled.input<any>`
  height: 51px;
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '6px 10px'};
  width: ${(props) => props.width || '100%'};
  min-width: ${(props) => props.minWidth || '100%'};
  max-width: ${(props) => props.maxWidth || '100%'};
  white-space: nowrap;
  background-color: transparent;
  outline: none;
  border-radius: ${(props) => props.borderRadius || '8px'};
  border: ${(props) => props.border || ''};
  position: relative;
  -webkit-appearance: none;
  color: white;

  font-size: 18px;

  ::placeholder {
    color: ${({ theme }) => theme.text3};
  }

  :focus {
    outline: none;
  }
`

const initialState = {
  start: '',
  end: '',
  postLifetime: '',
  duration: '',
  multiplier: '',
  title: '',
  description: '',
  docLink: '',
}

const Admin = () => {
  const [inputs, setInputs] = useState(initialState)

  const handleSetInputs = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputs((s) => ({ ...s, [e.target.name]: e.target.value }))
  }

  const handleCreateTask = async () => {
    try {
      const res = await agent.competition.createTask({
        ...inputs,
        start: new Date(inputs.start).getTime() / 1000,
        end: new Date(inputs.start).getTime() / 1000,
        postLifetime: +inputs.postLifetime,
        duration: +inputs.duration * 3600,
        multiplier: +inputs.multiplier,
      })
      setInputs(initialState)
      alert('Task Created')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Column gap="sm">
      <TextInput
        name="start"
        type="date"
        value={inputs.start}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="start"
      />
      <TextInput
        name="end"
        type="date"
        value={inputs.end}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="end"
      />
      <TextInput
        name="postLifetime"
        value={inputs.postLifetime}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="postLifetime"
      />
      <TextInput
        name="duration"
        value={inputs.duration}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="duration(hours)"
      />
      <TextInput
        name="multiplier"
        value={inputs.multiplier}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="multiplier"
      />
      <TextInput
        name="title"
        value={inputs.title}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="title"
      />
      <TextInput
        name="description"
        value={inputs.description}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="description"
      />
      <TextInput
        name="docLink"
        value={inputs.docLink}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSetInputs(e)}
        placeholder="docLink"
      />
      <ButtonPrimary onClick={handleCreateTask}>Create</ButtonPrimary>
    </Column>
  )
}

export default Admin
